import { CCStructureItem } from "../cclib/types/structure";

export const uclaDataSummaryStructureProfessor: CCStructureItem[] = [
  {
    type: "header",
    name: "BIOGRAPHICAL DATA"
  },
  {
    name: "Faculty Name",
    type: "string",
    key: "faculty_name",
    readOnly: true
  },
  {
    name: "Current Title",
    type: "string",
    key: "current_title",
    readOnly: true
  },
  {
    type: "custom",
    key: "custom-timeframe"
  },
  {
    type: "header",
    name: "TEACHING RECORD"
  },
  {
    type: "custom",
    key: "custom-teaching-record",
    notes: [
      {
        addRef: false,
        ref: "(1) ",
        type: "immediate",
        text: "If no undergraduate course is listed, please append statement of rationale for assignment of courses made to the candidate for indicated period."
      },
      {
        addRef: false,
        ref: "(2) ",
        type: "immediate",
        text: "Required for a major or to fulfill a lower division requirement."
      },
      {
        addRef: false,
        ref: "(3) ",
        type: "immediate",
        text: "If other faculty participated, please append statement describing character and extent of candidate's participation."
      }
    ]
  },
  {
    type: "header",
    name: "OTHER TEACHING ACTIVITIES"
  },
  {
    type: "custom",
    key: "custom-teaching-other"
  },
  {
    type: "custom",
    key: "custom-teaching-professor"
  },
  {
    type: "header",
    name: "UNIVERSITY COMMITTEE SERVICE"
  },
  {
    type: "custom",
    key: "custom-committee",
    notes: {
      addRef: false,
      ref: "",
      type: "immediate",
      text: "*Direct costs, your component only, (if multiple co-PI's)/ann. Note: when this is pulled from your CV the field pulls total costs as originally entered"
    }
  },
  {
    type: "header",
    name: "PROFESSIONAL ACTIVITIES SINCE LAST REVIEW, OR FOR FOURTH-YEAR APPRAISAL OR PROMOTION/8-YEAR LIMIT ACTION, CUMULATIVE SINCE APPOINTMENT",
    notes: {
      addRef: false,
      ref: "",
      type: "immediate",
      text: "Professional services related to diversity should be marked with “DIV” (e.g., involvement in professional associations or programs that support training of students in underrepresented groups; contributions to professional groups or publications that promote areas of knowledge that relate to diversity)."
    }
  },
  {
    type: "custom",
    key: "custom-activities"
  }
];
